import { makeAPIRequest } from './studentRequests'

export const getAllSchools = async (): Promise<any> => {
  let response: Response
  try {
    response = await makeAPIRequest('/schools', 'GET')
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const getAllDistricts = async (): Promise<any> => {
  let response: Response
  try {
    response = await makeAPIRequest('/districts', 'GET')
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const getStudentsPaginated = async ({
                                             page,
                                             pageSize,
                                             filterModel,
                                             classroomStartDateSortOrder,
                                           }: {
                                             page: number
                                             pageSize: number
                                             filterModel: any
                                             classroomStartDateSortOrder: string
                                           }): Promise<any> => {
  const data = {
    page,
    pageSize,
    filterModel,
    classroomStartDateSortOrder,
  }
  let response: Response
  try {
    response = await makeAPIRequest('/users/students/paginated', 'POST', data)
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const getPersonalUsersPaginated = async ({
                                             page,
                                             pageSize,
                                             filterModel,
                                           }: {
                                             page: number
                                             pageSize: number
                                             filterModel: any
                                           }): Promise<any> => {
  const data = {
    page,
    pageSize,
    filterModel,
  }
  let response: Response
  try {
    response = await makeAPIRequest('/users/personal-users/paginated', 'POST', data)
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const getAllTeachers = async (): Promise<any> => {
  let response: Response
  try {
    response = await makeAPIRequest('/users/teachers', 'GET')
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const getAllAdmins = async (): Promise<any> => {
  let response: Response
  try {
    response = await makeAPIRequest('/users/admins', 'GET')
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const getDistrictAdminsForDistrict = async (districtId: number | string): Promise<any> => {
  let response: Response
  try {
    response = await makeAPIRequest(`/users/districtAdmins/${districtId}`, 'GET')
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const deleteAdmin = async (id: number): Promise<boolean> => {
  let data = {
    userId: id,
  }
  try {
    const response = await makeAPIRequest('/users/admin', 'DELETE', data)
    if (response.status === 400) {
      throw new Error('Can\'t delete self.')
    }
  } catch (e) {
    if ((e as Error).toString() === 'Error: Can\'t delete self.') {
      throw e
    } else {
      throw new Error('There was an error deleting this admin. Please try again.')
    }
  }
  return true
}

export const deleteDistrictAdmin = async (id: number): Promise<boolean> => {
  let data = {
    userId: id,
  }
  try {
    const response = await makeAPIRequest('/users/districtAdmin', 'DELETE', data)
    if (response.status === 400) {
      throw new Error('Can\'t delete self.')
    }
  } catch (e) {
    if ((e as Error).toString() === 'Error: Can\'t delete self.') {
      throw e
    } else {
      throw new Error('There was an error deleting this admin. Please try again.')
    }
  }
  return true
}

export const addAdmin = async ({
                                 firstName,
                                 lastName,
                                 emailAddress,
                               }: {
                                 firstName: string
                                 lastName: string
                                 emailAddress: string
                               }): Promise<boolean> => {
  const data = {
    firstName,
    lastName,
    emailAddress,
  }
  try {
    const response = await makeAPIRequest('/users/admin', 'POST', data)
    if (response.status !== 200) {
      throw new Error('There was an error adding this admin.')
    }
  } catch (e) {
    throw new Error(e as string)
  }
  return true
}

export const addDistrictAdmin = async ({
                                 firstName,
                                 lastName,
                                 emailAddress,
                                 districtId,
                                 canManageAdmins,
                               }: {
                                 firstName: string
                                 lastName: string
                                 emailAddress: string
                                 districtId: number
                                 canManageAdmins: boolean
                               }): Promise<boolean> => {
  const data = {
    firstName,
    lastName,
    emailAddress,
    districtId,
    canManageAdmins,
  }
  try {
    const response = await makeAPIRequest('/users/districtAdmin', 'POST', data)
    if (response.status !== 200) {
      throw new Error('There was an error adding this admin.')
    }
  } catch (e) {
    throw new Error(e as string)
  }
  return true
}


export const createDistrict = async (data: Record<string, any>): Promise<any> => {
  let response: Response

  try {
    response = await makeAPIRequest('/districts', 'POST', data)
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const updateDistrict = async (districtId: number, data: Record<string, any>): Promise<any> => {
    let response: Response

    try {
        response = await makeAPIRequest(`/districts/${districtId}`, 'PUT', data)
    } catch (e) {
        throw new Error(e as string)
    }
    return response.json()
}

export const createSchool = async ({
                                     districtId,
                                     name,
                                     notes,
                                     city,
                                     state,
                                     country,
                                     type,
                                     isQASchool,
                                     timezone,
                                   }: {
                                     districtId: number
                                     name: string
                                     notes: string
                                     city: string
                                     state: string
                                     country: string
                                     type: string
                                     isQASchool: boolean
                                     timezone: string
                                   }): Promise<any> => {
  let response: Response
  const data = {
    districtId,
    name,
    notes,
    city,
    state,
    country,
    type,
    isQASchool,
    timezone,
  }
  try {
    response = await makeAPIRequest('/schools', 'POST', data)
    if (response.status !== 200) {
      throw new Error(String(response.status))
    }
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const resendTeacherInvite = async (
  {
    id,
  }: { id: number }): Promise<void> => {
  let response: Response
  const data = {
    id,
  }
  try {
    await makeAPIRequest('/users/resendInvite', 'POST', data)
  } catch (e) {
    throw new Error(e as string)
  }
}

export const retrieveTeacherInviteLink = async (
  {
    id,
  }: { id: number }): Promise<string> => {
  let response: Response
  const data = {
    id,
  }
  try {
    response = await makeAPIRequest('/users/retrieveTeacherInviteLink', 'POST', data)
    return (await response.json()).link
  } catch (e) {
    throw new Error(e as string)
  }
}

export const updateSchool = async ({
                                     districtId,
                                     name,
                                     type,
                                     city,
                                     state,
                                     country,
                                     notes,
                                     timezone,
                                     schoolId,
                                     isQASchool,
                                   }: {
                                     districtId?: number
                                     name?: string
                                     type?: string
                                     city?: string
                                     state?: string
                                     country?: string
                                     notes?: string
                                     timezone?: string
                                     schoolId: number
                                     isQASchool?: boolean
                                   }): Promise<any> => {
  let response: Response
  const data = {
    districtId,
    name,
    type,
    city,
    state,
    country,
    note: notes,
    timezone,
    isQASchool,
  }
  try {
    response = await makeAPIRequest(`/schools/${schoolId}`, 'PUT', data)
  } catch (e) {
    throw new Error(e as string)
  }
  return response.json()
}

export const inviteTeacher = async ({
                                      firstName,
                                      lastName,
                                      email,
                                      schoolId,
                                      shouldAddToMailchimp,
                                      jobTitle,
                                      educatorType,
                                      shouldSendEmail,
                                    }: {
                                      firstName: string
                                      lastName: string
                                      email: string
                                      schoolId: number
                                      shouldAddToMailchimp: boolean
                                      jobTitle: string
                                      educatorType: string
                                      shouldSendEmail: boolean
                                    }): Promise<[boolean, string | undefined]> => {
  let response: Response
  const data = {
    firstName,
    lastName,
    schoolId,
    emailAddress: email,
    shouldAddToMailchimp,
    jobTitle,
    educatorType,
    role: 'teacher',
    shouldSendEmail,
  }
  try {
    response = await makeAPIRequest(`/users/invite`, 'POST', data)
  } catch (e) {
    throw new Error(e as string)
  }
  const success = response.status.toString().startsWith('20')
  let errorMessage = undefined
  if (!success) {
    errorMessage = (await response.json()).message
  }
  return [success, errorMessage]
}

export const getCourseFromContentful = async (courseId: string): Promise<any> => {
  try {
    const response = await makeAPIRequest(`/courses/${courseId}/latestContentfulData`, 'GET')
    if (response.status !== 200) {
      throw new Error('Error getting course from contentful')
    }
    return response.json()
  } catch (e) {
    throw new Error(e as string)
  }
}

export const updateCourseWithLatestContentful = async (courseId: string, newVersion: boolean): Promise<void> => {
  try {
    const data = {
      newVersion,
    }
    const response = await makeAPIRequest(`/courses/${courseId}/updateCourseWithLatestContentful`, 'POST', data)
    if (response.status !== 200) {
      throw new Error('Error getting course from contentful')
    }
  } catch (e) {
    throw new Error(e as string)
  }
}

export type ForcedAlignmentResult = {
  status: 'success' | 'fail' | 'input_error'
  message?: string
  outputUrl?: string
}

export const generateForcedAlignment = async ({ s3Url, transcript }: { s3Url: string, transcript: string }): Promise<ForcedAlignmentResult> => {
  try {
    const response = await makeAPIRequest('/openAI/forcedAlignment', 'POST', { s3Url, transcript })
    if (response.status !== 200) {
      return { status: 'fail', message: 'Unexpected server error' }
    }
    return response.json()
  } catch (e) {
    return { status: 'fail', message: e as string }
  }
}

export const getDashboardStats = async (): Promise<any> => {
  try {
    const response = await makeAPIRequest('/dashboardStats', 'GET')
    if (response.status !== 200) {
      throw new Error('Error getting dashboard stats')
    }
    return response.json()
  } catch (e) {
    throw new Error(e as string)
  }
}

export const postRestrictUser = async (id: number): Promise<void> => {
  try {
    const data = {
      id,
    }
    const response = await makeAPIRequest('/users/restrictUser', 'POST', data)
    if (response.status !== 200) {
      throw new Error('Error restricting user')
    }
  } catch (e) {
    throw new Error(e as string)
  }
}

export const postMakePersonalQA = async (userId: number): Promise<void> => {
  try {
    const data = {
      userId,
    }
    const response = await makeAPIRequest('/users/personal-users/make-qa', 'POST', data)
    if (response.status !== 200) {
      throw new Error('Error restricting user')
    }
  } catch (e) {
    throw new Error(e as string)
  }
}

export const postAddTeacherToSchool = async ({ teacherId, schoolId }: { teacherId: number, schoolId: number }): Promise<void> => {
  try {
    const data = {
      teacherId,
      schoolId,
    }
    const response = await makeAPIRequest('/users/addTeacherToSchool', 'POST', data)
    if (response.status !== 200) {
      throw new Error('Error restricting user')
    }
  } catch (e) {
    throw new Error(e as string)
  }
}

export const postMoveUserVerificationStatusToPending = async (id: number): Promise<void> => {
  try {
    const data = {
      id,
    }
    const response = await makeAPIRequest('/users/moveUserVerificationStatusToPending', 'POST', data)
    if (response.status !== 200) {
      throw new Error('Error restricting user')
    }
  } catch (e) {
    throw new Error(e as string)
  }
}

export const updateTeacherName = async ({ firstName, lastName, id }: { firstName: string, lastName: string, id: number }): Promise<boolean> => {
  try {
    const data = {
      firstName,
      lastName,
      id,
    }
    const response = await makeAPIRequest('/users', 'PUT', data)
    if (response.status !== 200) {
      throw new Error('Error updating teacher name')
    }
    return true
  } catch (e) {
    throw new Error(e as string)
  }
}

export const deletePendingTeacher = async (id: number): Promise<void> => {
  try {
    const data = {
      userId: id,
    }
    const response = await makeAPIRequest('/users/pendingTeacher', 'DELETE', data)
    if (response.status !== 200) {
      throw new Error('Error deleting teacher account.')
    }
  } catch (e) {
    throw new Error(e as string)
  }
}

export const getDistrictAdminDashboardStats = async (districtId: number): Promise<any> => {
  try {
    const response = await makeAPIRequest(`/districts/dashboardStats/${districtId}`, 'GET')
    if (response.status !== 200) {
      throw new Error('Error getting district admin dashboard stats')
    }
    return response.json()
  } catch (e) {
    throw new Error(e as string)
  }
}
